/**
 * LoadFuelFailedModal — error dialog shown when a Stripe charge fails.
 *
 * Rebuilt off the legacy the legacy overlay as part of the the legacy component retirement.
 * Native `<button>` + the shared `Modal` primitive.
 */

import React, {ReactElement} from "react";
import {FiAlertOctagon, FiX} from "react-icons/fi";
import {Modal} from "@/widgets/Modal";
import "./LoadFuelFailedModal.scss";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    errorMessage?: string;
}

function LoadFuelFailedModal(props: Props): ReactElement {
    const defaultMessage =
        "There was a problem loading FUEL into your account. Try a different card or try again in a moment.";

    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.toggle}
            contentClassName="lfp2-failed-modal"
            size="xs"
            ariaLabel="Load Fuel Failed"
        >
            <button
                type="button"
                className="lfp2-failed-modal__close"
                onClick={props.toggle}
                aria-label="Close"
            >
                <FiX aria-hidden="true" />
            </button>

            <div className="lfp2-failed-modal__body">
                <div className="lfp2-failed-modal__icon">
                    <FiAlertOctagon aria-hidden="true" />
                </div>

                <h2 className="lfp2-failed-modal__title">Load Fuel Failed</h2>

                <p className="lfp2-failed-modal__copy">
                    {props.errorMessage || defaultMessage}
                </p>

                <div className="lfp2-failed-modal__cta-row">
                    <button
                        type="button"
                        className="lfp2-failed-modal__retry"
                        onClick={props.toggle}
                    >
                        Try Again
                    </button>
                    <button
                        type="button"
                        className="lfp2-failed-modal__cancel"
                        onClick={props.toggle}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default LoadFuelFailedModal;
